import React from 'react';
import { useForm, Link } from '@inertiajs/react';
import AuthLayout from '../layouts/AuthLayout';

export default function PasswordEdit({ user, csrf_token }) {
  const { data, setData, put, processing, errors } = useForm({
    password: '',
    password_confirmation: '',
    password_challenge: '',
    authenticity_token: csrf_token
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    put('/password');
  };

  return (
    <AuthLayout title="Change your password">
      <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
        <div className="rounded-md shadow-sm -space-y-px">
          <div>
            <label htmlFor="password_challenge" className="sr-only">Current Password</label>
            <input
              id="password_challenge"
              name="password_challenge"
              type="password"
              autoComplete="current-password"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Current Password"
              value={data.password_challenge}
              onChange={e => setData('password_challenge', e.target.value)}
            />
            {errors.password_challenge && <div className="text-red-500 text-sm mt-1">{errors.password_challenge}</div>}
          </div>
          <div>
            <label htmlFor="password" className="sr-only">New Password</label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="New Password"
              value={data.password}
              onChange={e => setData('password', e.target.value)}
            />
            {errors.password && <div className="text-red-500 text-sm mt-1">{errors.password}</div>}
          </div>
          <div>
            <label htmlFor="password_confirmation" className="sr-only">Confirm New Password</label>
            <input
              id="password_confirmation"
              name="password_confirmation"
              type="password"
              autoComplete="new-password"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Confirm New Password"
              value={data.password_confirmation}
              onChange={e => setData('password_confirmation', e.target.value)}
            />
            {errors.password_confirmation && <div className="text-red-500 text-sm mt-1">{errors.password_confirmation}</div>}
          </div>
        </div>

        <div>
          <button
            type="submit"
            disabled={processing}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {processing ? 'Updating password...' : 'Update password'}
          </button>
        </div>

        <div className="text-center">
          <Link href="/" className="font-medium text-indigo-600 hover:text-indigo-500">
            Back to home
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
}
